import { IHttpApi } from '@cian/http-api';
import { mergeBaseUri, mergePaths } from '@cian/http-api/shared';

import { filterServerResponse } from './helpers';
import {
  createAddFeedbackRequestModel,
  IAddFeedbackRequestRequest,
  TAddFeedbackRequestResponse,
} from '../repositories/moderation-complaints/v1/add-feedback-request';
import { getBrowserFingerprint } from '../utils/fingerprint';
import { IMakeRequest } from '../utils/make_request';

export type TComplaintBlockType = 'transitional' | 'textarea' | 'finish' | 'link';
export const ComplaintBlockType = {
  Finish: 'finish' as TComplaintBlockType,
  Textarea: 'textarea' as TComplaintBlockType,
  Transitional: 'transitional' as TComplaintBlockType,
  Link: 'link' as TComplaintBlockType,
};

export interface IComplaint {
  blockType: TComplaintBlockType;
  categories: number[];
  hint: string;
  id: string;
  items: IComplaint[];
  name: string;
  title: string;
  url?: string;
  isCommentRequired?: boolean;
  complaintOnSiteId: number;
}

export function getComplaintRequest(makeRequest: IMakeRequest, apiBaseUrl: string, regionId: number, category: number) {
  return makeRequest({
    method: 'GET',
    withCredentials: true,
    uri: mergeBaseUri(apiBaseUrl, {
      path: (path: string) => mergePaths(path, '/v2/get-complaint-types/'),
      query: [`categoryId=${category}`, `regionId=${regionId}`].join('&'),
    }),
  }).then(response => JSON.parse(response.responseBody));
}

export interface IAddComplaintOptions {
  complaintId: string;
  message?: string;
  offerRealtyId: number;
}

export interface IAddComplaintResponse {
  complaintId: number;
  getUserFeedback: boolean;
}

export function addComplaintRequest(
  makeRequest: IMakeRequest,
  apiBaseUrl: string,
  options: IAddComplaintOptions,
): Promise<IAddComplaintResponse> {
  const body = {
    realtyObjectId: options.offerRealtyId,
    complaintOnSiteId: options.complaintId,
    message: options.message ? options.message : null,
    userContextInfo: {
      uniqueId: getBrowserFingerprint(),
    },
  };

  return makeRequest({
    body: JSON.stringify(body),
    headers: [['Content-Type', 'application/json']],
    method: 'POST',
    withCredentials: true,
    uri: mergeBaseUri(apiBaseUrl, {
      path: (path: string) => mergePaths(path, '/v2/create-complaint/'),
    }),
  })
    .then(filterServerResponse)
    .then(response => JSON.parse(response.responseBody));
}

export function sendFeedbackFrom(httpApi: IHttpApi, parameters: IAddFeedbackRequestRequest) {
  return httpApi.fetch<IAddFeedbackRequestRequest, TAddFeedbackRequestResponse>(
    createAddFeedbackRequestModel(parameters),
    {
      requestConfig: {
        headers: [['Content-Type', 'application/json']],
        withCredentials: false,
      },
    },
  );
}
